var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.41699 2.3335H2.33366C2.02424 2.3335 1.72749 2.45641 1.5087 2.6752C1.28991 2.894 1.16699 3.19074 1.16699 3.50016V11.6668C1.16699 11.9762 1.28991 12.273 1.5087 12.4918C1.72749 12.7106 2.02424 12.8335 2.33366 12.8335H10.5003C10.8097 12.8335 11.1065 12.7106 11.3253 12.4918C11.5441 12.273 11.667 11.9762 11.667 11.6668V7.5835",
    stroke: "#325AE7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.792 1.45838C11.0241 1.22632 11.3388 1.09595 11.667 1.09595C11.9952 1.09595 12.3099 1.22632 12.542 1.45838C12.7741 1.69045 12.9044 2.0052 12.9044 2.33338C12.9044 2.66157 12.7741 2.97632 12.542 3.20838L7.00032 8.75005L4.66699 9.33338L5.25033 7.00005L10.792 1.45838Z",
    stroke: "#325AE7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.dd73c29e0982841b3e6a887dad739e59.svg";
export { ForwardRef as ReactComponent };